export default function TenderItemsTable({ items }) {
  return (
    <div className="space-y-6 ">
      {/* Header */}
      <div className="">
        <div className="flex items-center gap-2">
          <h2 className="text-base font-semibold">Items to Respond</h2>
          <span className="bg-blue-50 font-medium flex items-center gap-2 border border-blue-300 text-blue-600 text-xs px-2 py-0.5 rounded-full">
            <div className="rounded-full w-1.5 h-1.5 bg-blue-500" />
            {items.length} Items
          </span>
        </div>
        <p className="text-gray-600 text-xs mt-1">
          Tender Items that you need to respond to
        </p>
      </div>

      <div className="space-y-4">
        {items.map((item, index) => (
          <div key={item.id} className="bg-white overflow-hidden">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center font-semibold">
                {index + 1}
              </div>
              <div className="pb-4 flex-1">
                <div className="mb-2">
                  <div className="text-sm font-semibold text-blue-600">
                    Item No : {index + 1}
                  </div>
                  <h3 className="font-medium text-gray-900">
                    Tender Item header information will goes here
                  </h3>
                </div>
                <div className="col-span-4 space-y-2 divide-y">
                  <div className="grid grid-cols-12">
                    <div className="col-span-3 text-sm">
                      Unit of Measurement
                    </div>
                    <div className="col-span-9 font-semibold text-sm">
                      {item.uom || "-"}
                    </div>
                  </div>
                  <div className="grid grid-cols-12 pt-2">
                    <div className="col-span-3 text-sm">Required Quantity</div>
                    <div className="col-span-9 font-semibold text-sm">
                      {item.estimate_quantity}
                    </div>
                  </div>
                  <div className="grid grid-cols-12 pt-2">
                    <div className="col-span-3 text-sm">Remark</div>
                    <div className="col-span-9 font-semibold text-sm">No</div>
                  </div>
                </div>
                <div className="mt-6 ">
                  <div className="bg-white rounded-lg border border-gray-200">
                    <div className="px-6 py-4 flex justify-between items-center border-b border-gray-200">
                      <div className="flex items-center gap-2">
                        <h2 className="text-base text-gray-900 font-semibold">
                          Delivery Information
                        </h2>
                      </div>
                    </div>
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr className="bg-gray-50">
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500"
                          >
                            Location
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500"
                          >
                            Delivery Date
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500"
                          >
                            Quantity
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500"
                          >
                            Delivery Terms
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        <tr>
                          <td className="px-6 py-4 text-xs text-gray-500">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item.notes_to_supplier,
                              }}
                            ></span>
                          </td>
                          <td className="px-6 py-4 text-xs text-gray-500">
                            Jan 4, 2025
                          </td>
                          <td className="px-6 py-4 text-xs text-gray-500">
                            {item.estimate_quantity}
                          </td>
                          <td className="px-6 py-4 text-xs text-gray-500">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
